import React from 'react';
import { useTranslation } from 'react-i18next';
import { motion } from 'framer-motion';
import HeroSection from '../../components/sections/HeroSection';
import FeaturesSection from '../../components/sections/FeaturesSection';
import CoursesPreview from '../../components/sections/CoursesPreview';
import Testimonials from '../../components/sections/Testimonials';
import StatsSection from '../../components/sections/StatsSection';
import CtaSection from '../../components/sections/CtaSection';
import SEO from '../../components/common/SEO';

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <SEO 
        title={t('seo.homeTitle')} 
        description={t('seo.homeDescription')}
      />
      
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <HeroSection />
        <FeaturesSection />
        <CoursesPreview />
        <Testimonials />
        <StatsSection />
        <CtaSection />
      </motion.div>
    </>
  );
};

export default Home;